function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-3_svg__filter0_f)"
}, React.createElement("path", {
  d: "M344.143 252.993l6.053 12.136 1.224 7.859-7.347-4.781-6.726-14.166 3.119-4.971 3.677 3.923z",
  fill: "#D5D4D4"
}), React.createElement("path", {
  d: "M340.466 249.07l3.677 3.923 6.053 12.136 1.224 7.859m-10.954-23.918l-3.119 4.971 6.726 14.166 7.347 4.781m-10.954-23.918l10.954 23.918",
  stroke: "#969696",
  strokeWidth: 1.862
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-3_svg__filter1_f)"
}, React.createElement("path", {
  d: "M28.479 34.165l-11.266 7.55-7.638 2.217 3.805-7.897 13.193-8.478 5.328 2.46-3.422 4.148z",
  fill: "#D5D4D4"
}), React.createElement("path", {
  d: "M31.9 30.018l-3.421 4.147-11.266 7.55-7.638 2.217M31.9 30.018l-5.328-2.46-13.193 8.477-3.805 7.897M31.9 30.018L9.575 43.932",
  stroke: "#969696",
  strokeWidth: 1.862
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5,
  filter: "url(#leaf-3_svg__filter2_f)"
}, React.createElement("path", {
  d: "M96.436 438.524l-5.9 25.753-8.016 13.397-5.4-16.187 7.413-29.648 11.132-3.734.77 10.419z",
  fill: "#D5D4D4"
}), React.createElement("path", {
  d: "M95.665 428.105l.77 10.419-5.9 25.753-8.015 13.397m13.145-49.569l-11.132 3.734-7.413 29.648 5.4 16.187m13.145-49.569L82.52 477.674",
  stroke: "#969696",
  strokeWidth: 1.862
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "leaf-3_svg__filter0_f",
  x: 326.067,
  y: 242.313,
  width: 38.913,
  height: 39.647,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.62,
  result: "effect1_foregroundBlur"
})), React.createElement("filter", {
  id: "leaf-3_svg__filter1_f",
  x: 0.545,
  y: 16.577,
  width: 38.082,
  height: 40.246,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.62,
  result: "effect1_foregroundBlur"
})), React.createElement("filter", {
  id: "leaf-3_svg__filter2_f",
  x: 68.47,
  y: 421.602,
  width: 37.101,
  height: 63.881,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.62,
  result: "effect1_foregroundBlur"
})));

var SvgLeaf3 = function SvgLeaf3(props) {
  return React.createElement("svg", _extends({
    width: 372,
    height: 486,
    viewBox: "0 0 372 486",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,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";
export { SvgLeaf3 as ReactComponent };